import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/due-course-mapping';

export async function listDueCourseMappings(params = {}) {
  const response = await axiosInstance.get(BASE_PATH, { params });
  return response.data;
}

export async function getDueCourseMappingOptions() {
  const response = await axiosInstance.get(`${BASE_PATH}/options`);
  return response.data;
}

export async function createDueCourseMapping(payload) {
  const response = await axiosInstance.post(BASE_PATH, payload);
  return response.data;
}

export async function updateDueCourseMapping(id, payload) {
  const response = await axiosInstance.put(`${BASE_PATH}/${id}`, payload);
  return response.data;
}

export async function updateStaffDueCourseMappings(staffId, payload) {
  const response = await axiosInstance.put(`${BASE_PATH}/staff/${staffId}`, payload);
  return response.data;
}

export async function deleteDueCourseMapping(id) {
  const response = await axiosInstance.delete(`${BASE_PATH}/${id}`);
  return response.data;
}

export async function deleteStaffDueCourseMappings(staffId) {
  const response = await axiosInstance.delete(`${BASE_PATH}/staff/${staffId}`);
  return response.data;
}

export default {
  listDueCourseMappings,
  getDueCourseMappingOptions,
  createDueCourseMapping,
  updateDueCourseMapping,
  updateStaffDueCourseMappings,
  deleteDueCourseMapping,
  deleteStaffDueCourseMappings,
};